import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.664 9.126A3.54 3.54 0 0 1 7.6 6.6C7.6 4.607 9.262 3 11.303 3c1.841 0 3.495 1.29 3.495 3.638 0 .936.377 1.575 1.202 1.954.825-.379 1.202-1.018 1.202-1.954C17.202 4.29 18.856 3 20.697 3c2.04 0 3.703 1.607 3.703 3.6 0 .984-.405 1.873-1.06 2.522q.905.027 1.777.061A3 3 0 0 1 28 12.181v3.071c0 .579-.06.887-.231 1.208-.16.3-.4.539-.7.7a2 2 0 0 1-.262.115q.004.587 0 1.667l-.002.769v.087l-.005 1.107v.105q0 3.162-.2 5.286a3 3 0 0 1-2.716 2.706q-4.624.42-7.853.42-3.235 0-7.913-.422A3 3 0 0 1 5.4 26.294q-.2-2.124-.2-5.283v-.107c0-.135 0-.27-.005-1.126v-.07l-.003-.765q-.003-1.081 0-1.669a2 2 0 0 1-.261-.115c-.3-.16-.54-.4-.7-.7C4.06 16.138 4 15.83 4 15.252v-3.068a3 3 0 0 1 2.885-2.998q.876-.033 1.78-.06m-1.733 1.26q3.157-.121 6.669-.153v5.957H6.138c-.397 0-.518-.023-.641-.09a.5.5 0 0 1-.208-.207c-.066-.123-.089-.244-.089-.641v-3.068a1.8 1.8 0 0 1 1.731-1.799m-.54 7.004H13.6v10.779q-2.384-.095-5.374-.364a1.8 1.8 0 0 1-1.631-1.624Q6.4 24.12 6.4 21.011v-.11c0-.135 0-.27-.005-1.127v-.07l-.003-.765q-.003-.98 0-1.549m9.64 10.831q-.592 0-1.235-.014l.004-.066V10.225a283 283 0 0 1 2.4 0V28.14q0 .034.004.067-.609.013-1.173.013m2.368-.05q2.39-.093 5.376-.364a1.8 1.8 0 0 0 1.63-1.624q.195-2.063.195-5.172v-.108l.004-1.073v-.124l.004-.768q.003-.98 0-1.547H18.4zm.001-11.98h7.462c.397 0 .518-.024.641-.09a.5.5 0 0 0 .208-.207c.066-.124.089-.245.089-.642V12.18a1.8 1.8 0 0 0-1.73-1.799q-3.115-.12-6.67-.15zM20.697 9C22.084 9 23.2 7.92 23.2 6.6s-1.116-2.4-2.503-2.4c-1.235 0-2.295.827-2.295 2.438 0 .97-.299 1.751-.872 2.333Q19.614 9 20.697 9m-9.394-4.801c1.234 0 2.295.827 2.295 2.438 0 .97.299 1.751.871 2.333Q12.387 9 11.303 9C9.916 9 8.8 7.92 8.8 6.6s1.116-2.4 2.503-2.4",
      clipRule: "evenodd"
    }
  )
);
var SvgGiftOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var GiftOutlined_default = SvgGiftOutlined;

export { GiftOutlined_default as default };
